<script setup lang="ts">
import { LabelledOptionWithChildren, ListDefinition } from "~/api";
import FormListsSelector from "./FormListsSelector.vue";
import RecursiveListsSelector from "./RecursiveListsSelector.vue";
import { ref } from "vue";

const props = defineProps<{
  formDefinitionGuid: string;
  listDefinitions: ListDefinition[];
  readOnly?: boolean;
}>();

const modelValue = defineModel<LabelledOptionWithChildren[]>({
  required: true,
});

const activeCollapseItems = ref([]);
</script>

<template>
  <div class="form-lists-selector">
    <div class="select-list">
      <span>Predefined List</span>
      <FormListsSelector
        v-model="modelValue"
        :form-definition-guid="formDefinitionGuid"
        :list-definitions="listDefinitions"
        :read-only="readOnly"
      />
    </div>

    <el-collapse
      v-if="modelValue.length > 0"
      v-model="activeCollapseItems"
      class="list-option"
    >
      <el-collapse-item
        v-for="option in modelValue"
        :key="option.value"
        :title="
          option.label +
          ' - ' +
          option.value +
          (option.children.length > 0 ? ' &nbsp; &nbsp; (with sub list)' : '')
        "
        :name="option.label"
      >
        <RecursiveListsSelector
          v-model="option.children"
          :form-definition-guid="formDefinitionGuid"
          :list-definitions="listDefinitions"
          :read-only="readOnly"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style lang="less">
.form-lists-selector {
  margin-left: 0.5em;

  .select-list {
    display: flex;
    align-items: baseline;
    gap: 1em;
    margin: 0.5em;
    > span {
      white-space: nowrap;
    }
  }

  .ListSelector {
    .select-button {
      margin: 5px 0 5px 0;
    }
  }

  .el-collapse-item__wrap {
    border-bottom: none;
  }

  .list-option {
    display: grid;
    gap: 10px;
    margin: 0.5em 0 0 2em;
    text-wrap: nowrap;

    > :first-child {
      margin-top: 0;
    }
  }
}
</style>
